import { UploadMedia } from '@anm/api/modules/uploads';
import getExtensionFromPath from '@anm/helpers/getExtensionFromPath';

const isMP4 = (file: UploadMedia) => getExtensionFromPath(file.request.url) === 'mp4';

export default isMP4;
